const isTouchDevice = ()=>{
    return ("ontouchstart" in document.documentElement || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0 );
}

const isIOS = ()=> {
   return isTouchDevice() &&  /macintosh|ipad|iphone|ipod/.test(navigator.userAgent.toLowerCase());
}

const isSafari = ()=>{
    return !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
}


const deviceType = () => {
    const ua = navigator.userAgent;
    if (isIOS() || /(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        return "tablet";
    }
    else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
        return "mobile";
    }
    return "desktop";
};


export {isTouchDevice, isIOS, deviceType, isSafari}